import { format as formatDateFns } from 'date-fns'
import { es } from 'date-fns/locale'
const MX_TIMEZONE = 'America/Mexico_City'

/**
 * @name dateFormatter.ts
 * @version 1.0.0
 * @description Utilidades para formateo de fechas
 * @author
 * @changelog
 * 1.0.0 - 2024/01/01 - @usuario - Función consolidada de formateo de fechas
 */

/**
 * Formatea una fecha a formato legible
 * @description Formatea fechas a diferentes formatos según el parámetro format
 * @param date Fecha a formatear (Date, number, string o undefined)
 * @param format Formato opcional ('YYYY-MM-DD HH:mm', 'es-MX', o undefined para formato por defecto)
 * @returns Fecha formateada como string
 */
export const formatDate = (date: Date | number | string | undefined, format?: string): string => {
	if (!date) return 'No disponible'

	let dateToFormat: Date

	// Si es string con formato YYYY-MM-DD, agregar tiempo
	if (typeof date === 'string' && /^\d{4}-\d{2}-\d{2}$/.test(date)) {
		dateToFormat = new Date(date + 'T00:00:00')
	} else {
		dateToFormat = new Date(date)
	}

	// Validar que la fecha sea válida
	if (Number.isNaN(dateToFormat.getTime())) return 'No disponible'

	// Formato específico YYYY-MM-DD HH:mm
	if (format === 'YYYY-MM-DD HH:mm') {
		return formatDateFns(dateToFormat, 'yyyy-MM-dd HH:mm')
	}
	if (format === 'YYYY-MM-DD') {
		return formatDateFns(dateToFormat, 'yyyy-MM-dd')
	}
	if (format === 'DD/MM/YYYY') {
		return dateToFormat.toLocaleString('es-MX', {
			day: '2-digit',
			month: '2-digit',
			year: 'numeric',
			timeZone: MX_TIMEZONE
		})
	}
	if (format === 'es-MX') {
		// Formato es-MX (dd/mm/yyyy)
		return dateToFormat.toLocaleString('es-MX', {
			day: '2-digit',
			month: '2-digit',
			year: 'numeric',
			timeZone: MX_TIMEZONE
		})
	}
	if (format === 'es-MX-HH:mm') {
		return dateToFormat.toLocaleString('es-MX', {
			day: '2-digit',
			month: '2-digit',
			year: 'numeric',
			hour: '2-digit',
			minute: '2-digit',
			timeZone: MX_TIMEZONE
		})
	}

	// Formato por defecto (dd MMMM yyyy en español)
	return formatDateFns(dateToFormat, 'dd MMMM yyyy', { locale: es })
}
